import { Col, Row } from 'antd';
import React from 'react';
import Title from 'antd/es/typography/Title';
import TripsTaxiTable from './Components/TripsTaxiTable';
import { TripsTaxiInfoProvider } from './hooks/useCurrentTrip';

const TripsTaxiView = () => {
    return (
        <>
            <Row style={{ paddingBottom: 10, paddingTop: 10 }}>
                <Col span={12}>
                    <Title level={3}>Trips Taxi</Title>
                </Col>
            </Row>
            <div style={{ flex: '1 1 auto' }}>
                <TripsTaxiInfoProvider>
                    <TripsTaxiTable />
                </TripsTaxiInfoProvider>
            </div>
        </>
    );
};
export default TripsTaxiView;
